export class ValidationError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'ValidationError';
	}
}

export class DuplicationError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'DuplicationError';
	}
}

export class IllegalStateError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'IllegalStateError';
	}
}

export class IllegalActionError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'IllegalActionError';
	}
}
